import "./Pages.css";
import CountyCard from "../components/CountyCard.js";
import NonProfitCard from "../components/NonProfitCard.js";
import CentersCard from "../components/CentersCard";
import { useParams } from "react-router-dom";
import CustomPagination from "../components/Pagination.js";
import React from "react";
import Spinner from "react-bootstrap/Spinner";

export default function SearchAll() {
  const { term } = useParams();
  const [selected, setSelected] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(1);
  const [cardData, setCardData] = React.useState(null);
  const [instanceCount, setInstanceCount] = React.useState([0, 0]);

  function onPageChange(value) {
    setSelected(value);
  }

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_FLASK_URL}/search/all?term=${term}&page=${selected}`
        );
        const data = await response.json();
        // console.log(data);
        setCardData(data.results);
        setTotalPages(data.pages);
        setInstanceCount([data.total, data?.results.length]);
      } catch (error) {
        console.error("Error fetching rows:", error);
      }
    };

    fetchData();
  }, [term, selected]);

  return (
    <>
      <div>
        <h1 id="search-results">Search Results for "{term}"</h1>
      </div>
      {cardData === null && (
        <div className="container d-flex flex-wrap gap-3 justify-content-center">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}
      <div className="container d-flex flex-wrap justify-content-center">
        <div className="d-flex flex-wrap gap-3 justify-content-center">
          {cardData?.map((item, index) => {
            switch (item.type) {
              case "county":
                return (
                  <CountyCard key={index} county={item} searchTerm={term} />
                );
              case "nonprofit":
                return (
                  <NonProfitCard
                    key={index}
                    nonprofit={item}
                    searchTerm={term}
                  />
                );
              case "center":
                return (
                  <CentersCard key={index} center={item} searchTerm={term} />
                );
              default:
                return null;
            }
          })}
        </div>
        <CustomPagination
          last={totalPages}
          selected={selected}
          onPageChange={onPageChange}
          total={instanceCount[0]}
          current={instanceCount[1]}
        ></CustomPagination>
      </div>
    </>
  );
}
